// extracted by mini-css-extract-plugin
export default {"modal":"modal-GIYniSV","small":"small-BeMNkl1","medium":"medium-faBgWQb","large":"large-HFCyrLz","modal-content":"modal-content-OyX4LOV"};